<section class="safetyprogramrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Career Opportunities</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>




<section id="faq" class="faq section-bg" *ngIf="careerList.length>0">
    <div class="container">

        <div class="section-title">
            <h2>Current Opportunities</h2>
        </div>

        <div class="faq-list">
            <ul>
                <li *ngFor="let faq of careerList" data-aos="fade-up" data-aos-delay="100">

                    <i class="bx bx-briefcase icon-help"></i>
                    <a data-toggle="collapse" href="#cl{{faq.id}}" class="collapsed">{{faq.title}} (Location :
                        {{faq.location}})
                        
                        <i class="bx bx-chevron-down icon-show"></i><i class="bx bx-chevron-up icon-close"></i>
                    </a>
                    
                    <!-- <div class="pull-right">
                            <
                        </div> -->
                    
                    <div id="cl{{faq.id}}" class="collapse" data-parent=".faq-list">
                        <div [innerHtml]="faq.jd"></div>
                        <br/>
                        <a href="{{faq.link}}" class="p-0" target="_blank">
                            <button class="btn btn-small btn-primary">Apply</button>
                            </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</section>


<!-- <section id="faq" class="faq section-bg" *ngIf="careerList.length===0">
    <div class="container">

        <div class="section-title">
            <p>Sorry, we currently do not have any career opportunities available, please check back with us later. If you’d like to be considered for future openings, you may still submit your resume to: <a href="mailTo:careers@sficompliance.com">careers@sficompliance.com</a>. Thank you and stay safe!”</p>
        </div>
    </div>
</section> -->
<!-- <div class="my-4 d-flex justify-content-center align-item-center">
<recruitment-current-openings
  cid="b5ecc6b3-de3a-4d59-b620-81ce67cc78fa"
  ccid="19000101_000003"
  host="DP"
  locale="en_US">
</recruitment-current-openings>
</div> -->
<div class="container">
    <div id="ziprecruiter-widget-container" class="zip-widget-container"></div>
</div>